var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.lastUpdate)?_c('div',{staticClass:"dashboard-col"},[_c('span',{staticClass:"update"},[_vm._v(" "+_vm._s(_vm.$t('Dashboard.LastUpdate') + ' ')+" "+_vm._s(_vm.lastUpdate)+" ")]),(_vm.separator)?_c('span',{staticClass:"update ml-2"},[_vm._v("•")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }